

import { FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode } from 'react';
import { SceletonProps } from './slideNavigation';
import styled from 'styled-components';
import { useMemo } from 'react';

export interface SlideNavigationLayoutProps extends SceletonProps {
    isLoading?: boolean;
    content?: ReactNode;
    line?: ReactNode;
    autoWidth?: boolean;
    stretch?: boolean;
    autoFlex?: boolean;
    isDesigner?: boolean;
    fullWidth?: boolean;
}

const ContentWrapper = styled(FlexBox)`

::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
}
::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
    visibility: hidden;
}
::-webkit-scrollbar-thumb {
    border-radius: 310px; /* закругления плашки */
    background: transparent;
    visibility: hidden;
}
`;

export const SlideNavigationLayout: FC<SlideNavigationLayoutProps> = (props) => {
    const { isLoading, content, autoWidth, stretch, fullWidth, autoFlex, sceletonOptions, isDesigner } = props;
    
    const defaultSceleton = useMemo(() => {
        if (sceletonOptions) {
            const arr: any = []
            arr.length = sceletonOptions.col
            return (
                <FlexBox gx={sceletonOptions.gx} align="center" style={{ placeItems: 'center' }}>
                    {
                        arr.fill(1).map((i: any) => {
                            return (
                                <Skeleton width={sceletonOptions.w} height={sceletonOptions.h} />
                            )
                        })
                    }         
                </FlexBox>
            )
        }
        else {
            return (
                <FlexBox gx={24}>
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                </FlexBox>
            )
        }
    }, [sceletonOptions]);
    return (
        <FlexBox
            direction={'column'}
            width={autoWidth ? 'auto' : '100%'}
            flex={autoFlex ? '1' : undefined}
            className={'snl'}
        >
            <ContentWrapper 
    // @ts-ignore
    style={{ width: isDesigner && (!stretch && !fullWidth) ? 'fit-content' : '100%', minHeight: 24, alignItem: "center", overflowX: 'visible', position: 'relative', marginBottom: 0 }} width={'100%'}>
                {isLoading ? (
                    defaultSceleton
                ) : (
                    content
                )}
            </ContentWrapper>
        </FlexBox>
    );
};


import { FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode } from 'react';
import { SceletonProps } from './slideNavigation';
import styled from 'styled-components';
import { useMemo } from 'react';

export interface SlideNavigationLayoutProps extends SceletonProps {
    isLoading?: boolean;
    content?: ReactNode;
    line?: ReactNode;
    autoWidth?: boolean;
    stretch?: boolean;
    autoFlex?: boolean;
    isDesigner?: boolean;
    fullWidth?: boolean;
}

const ContentWrapper = styled(FlexBox)`

::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
}
::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
    visibility: hidden;
}
::-webkit-scrollbar-thumb {
    border-radius: 310px; /* закругления плашки */
    background: transparent;
    visibility: hidden;
}
`;

export const SlideNavigationLayout: FC<SlideNavigationLayoutProps> = (props) => {
    const { isLoading, content, autoWidth, stretch, fullWidth, autoFlex, sceletonOptions, isDesigner } = props;
    
    const defaultSceleton = useMemo(() => {
        if (sceletonOptions) {
            const arr: any = []
            arr.length = sceletonOptions.col
            return (
                <FlexBox gx={sceletonOptions.gx} align="center" style={{ placeItems: 'center' }}>
                    {
                        arr.fill(1).map((i: any) => {
                            return (
                                <Skeleton width={sceletonOptions.w} height={sceletonOptions.h} />
                            )
                        })
                    }         
                </FlexBox>
            )
        }
        else {
            return (
                <FlexBox gx={24}>
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                </FlexBox>
            )
        }
    }, [sceletonOptions]);
    return (
        <FlexBox
            direction={'column'}
            width={autoWidth ? 'auto' : '100%'}
            flex={autoFlex ? '1' : undefined}
            className={'snl'}
        >
            <ContentWrapper 
    // @ts-ignore
    style={{ width: isDesigner && (!stretch && !fullWidth) ? 'fit-content' : '100%', minHeight: 24, alignItem: "center", overflowX: 'visible', position: 'relative', marginBottom: 0 }} width={'100%'}>
                {isLoading ? (
                    defaultSceleton
                ) : (
                    content
                )}
            </ContentWrapper>
        </FlexBox>
    );
};
